// external imports
import React from 'react'
import { FlexColumn, Cycle, BooleanState, FlexRow } from 'quark-web'
// local imports
import { Text } from '~/components'
import Indicator from './Indicator'
import SlideControl from './Control'
import styles from './styles'

const Slideshow = ({ children }) => (
    <BooleanState>
        {({ state: hover, set: setHover }) => (
            <Cycle items={children} interval={7000} active={!hover}>
                {({ index, next, previous, goTo }) => (
                    <React.Fragment>
                        <FlexRow
                            grow={1}
                            style={styles.imageContainer}
                            onMouseEnter={() => setHover(true)}
                            onMouseLeave={() => setHover(false)}
                        >
                            {children.length > 0 ? (
                                children.map((url, i) => (
                                    <div
                                        key={url}
                                        style={{
                                            ...styles.image,
                                            backgroundImage: `url("${url}")`,
                                            opacity: i === index ? 1 : 0
                                        }}
                                    />
                                ))
                            ) : (
                                <div style={styles.image} />
                            )}
                            {hover &&
                                children.length > 0 && (
                                    <React.Fragment>
                                        <SlideControl side="left" onClick={previous} />
                                        <SlideControl side="right" onClick={next} />
                                    </React.Fragment>
                                )}
                        </FlexRow>
                        {children.length > 0 && (
                            <FlexRow
                                justifyContent="center"
                                style={{
                                    marginBottom: 28
                                }}
                            >
                                {children.map((url, i) => (
                                    <Indicator key={url} active={i === index} onClick={() => goTo(i)} />
                                ))}
                            </FlexRow>
                        )}
                    </React.Fragment>
                )}
            </Cycle>
        )}
    </BooleanState>
)

export default Slideshow



// WEBPACK FOOTER //
// ./src/components/Slideshow/index.js